import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    "nav.explore": "Explore Mandis",
    "nav.roles": "Roles",
    "nav.services": "Services",
    "nav.blog": "Mandi Gyan",
    "nav.trade": "State Rates",
    "nav.login": "Log In",
    "nav.get_started": "Get Started",
    "hero.eyebrow": "One Bharat • One Mandi",
    "hero.title_1": "Weave every mandi across",
    "hero.title_2": "Bharat into a single thread.",
    "hero.subtitle": "India's first pan-India B2B trade platform for farmers, mandis, traders, wholesalers and exporters — with verified counterparties, GST-ready billing and reliable logistics.",
    "hero.cta_primary": "Start Trading Free",
    "hero.cta_secondary": "Explore Mandis",
    "hero.cta_trade": "State Rates and Trade Route",
    "hero.metric_1": "22+ Mandis",
    "hero.metric_1_sub": "across 15 States",
    "hero.metric_2": "₹50 Cr+",
    "hero.metric_2_sub": "GMV Target 2026",
    "hero.metric_3": "5,000+",
    "hero.metric_3_sub": "Verified Traders",
    "how.eyebrow": "How it works",
    "how.title": "One deal. Four moments of trust.",
    "how.subtitle": "Every deal on India Mandi moves through four visible checkpoints — no phone calls, no chasing, no surprises.",
    "how.step_1_title": "Deal Matched",
    "how.step_1_desc": "AI-powered matching pairs your listing with the closest, best-priced counterparty.",
    "how.step_2_title": "Payment Confirmed",
    "how.step_2_desc": "Buyer pays; the transaction is verified & recorded on the ledger for both sides.",
    "how.step_3_title": "In Transportation",
    "how.step_3_desc": "Verified logistics partners with live tracking. ETA visible to both parties.",
    "how.step_4_title": "Delivered",
    "how.step_4_desc": "Buyer confirms, payment settled, GST invoice auto-generated. Rate each other.",
    "roles.eyebrow": "Built for every player in the chain",
    "roles.title": "Six roles. One platform.",
    "services.eyebrow": "Everything a trader needs",
    "services.title": "Beyond the deal — we handle the paperwork.",
    "trust.eyebrow": "Trust runs on data",
    "trust.title": "Every seller. Every rate. Verified.",
    "blog.eyebrow": "Mandi Gyan",
    "blog.title": "Sharper trader, every week.",
    "cta.title": "Ready to trade the modern way?",
    "cta.sub": "Join 5,000+ farmers, traders and exporters who moved from phone-call trading to a single platform.",
    "footer.tagline": "A GLC Zone Initiative — Mandi.GLCZone.in",
    "auth.login_title": "Welcome back to India Mandi",
    "auth.login_sub": "One login. Every mandi. Real trust.",
    "auth.register_title": "Join India Mandi",
    "auth.register_sub": "Pick your role, verify once, trade forever.",
    "auth.email": "Email address",
    "auth.password": "Password",
    "auth.name": "Full name / Business name",
    "auth.phone": "Phone",
    "auth.state": "State",
    "auth.district": "District",
    "auth.pincode": "PIN code",
    "auth.role_pick": "I am a...",
    "auth.have_account": "Already have an account?",
    "auth.no_account": "New to India Mandi?",
    "auth.login_btn": "Log In",
    "auth.register_btn": "Create Account",
    "dash.overview": "Overview",
    "dash.listings": "Listings",
    "dash.deals": "Deals",
    "dash.payments": "Payments",
    "dash.invoices": "Invoices",
    "dash.mandis": "Mandi Search",
    "dash.rates": "Aaj Ka Bhav",
    "dash.trade": "State Rates & Route",
    "dash.blog": "Mandi Gyan",
    "dash.notifications": "Notifications",
    "dash.admin_users": "Users",
    "dash.admin_deals": "All Deals",
    "dash.admin_kyc": "KYC papers",
    "dash.kyc": "My KYC",
    "dash.logout": "Log Out",
    "kpi.viewall": "View all",
    "listings.create": "Create Listing",
    "listings.type": "Type",
    "listings.commodity": "Commodity",
    "listings.qty": "Quantity",
    "listings.price": "Price (₹/quintal)",
    "listings.location": "Location",
    "listings.sell": "Sell",
    "listings.buy": "Buy",
    "listings.notes": "Notes / Grade",
    "listings.submit": "Publish Listing",
    "deal.status.matched": "Matched",
    "deal.status.payment_secured": "Payment Secured",
    "deal.status.in_transport": "In Transportation",
    "deal.status.delivered": "Delivered",
    "deal.advance": "Advance to next stage",
    "deal.finalize": "Confirm Delivery",
  },
  hi: {
    "nav.explore": "मंडियाँ खोजें",
    "nav.roles": "भूमिकाएँ",
    "nav.services": "सेवाएँ",
    "nav.blog": "मंडी ज्ञान",
    "nav.trade": "राज्य भाव",
    "nav.login": "लॉग इन",
    "nav.get_started": "शुरू करें",
    "hero.eyebrow": "एक भारत • एक मंडी",
    "hero.title_1": "भारत की हर मंडी को",
    "hero.title_2": "एक ही धागे में पिरोइये।",
    "hero.subtitle": "किसानों, मंडियों, व्यापारियों, थोक विक्रेताओं और निर्यातकों के लिए भारत का पहला पैन-इंडिया B2B ट्रेड प्लेटफ़ॉर्म — सत्यापित पार्टनर, GST-रेडी बिलिंग और भरोसेमंद लॉजिस्टिक्स।",
    "hero.cta_primary": "मुफ़्त शुरू करें",
    "hero.cta_secondary": "मंडियाँ देखें",
    "hero.cta_trade": "राज्य भाव और ट्रेड रूट",
    "hero.metric_1": "22+ मंडियाँ",
    "hero.metric_1_sub": "15 राज्यों में",
    "hero.metric_2": "₹50 करोड़+",
    "hero.metric_2_sub": "2026 GMV लक्ष्य",
    "hero.metric_3": "5,000+",
    "hero.metric_3_sub": "सत्यापित व्यापारी",
    "how.eyebrow": "कैसे काम करता है",
    "how.title": "एक सौदा। भरोसे के चार पड़ाव।",
    "how.subtitle": "इंडिया मंडी पर हर सौदा चार दिखने वाले पड़ावों से गुज़रता है — कोई फ़ोन कॉल, कोई पीछा, कोई सरप्राइज़ नहीं।",
    "how.step_1_title": "सौदा हुआ",
    "how.step_1_desc": "AI आपकी लिस्टिंग को सबसे नज़दीकी, सबसे अच्छे रेट वाले पार्टनर से जोड़ता है।",
    "how.step_2_title": "पेमेंट कन्फ़र्म",
    "how.step_2_desc": "खरीदार भुगतान करता है; लेन-देन दोनों पक्षों के लिए दर्ज होता है।",
    "how.step_3_title": "ट्रांसपोर्ट में",
    "how.step_3_desc": "सत्यापित लॉजिस्टिक्स पार्टनर, लाइव ट्रैकिंग, दोनों को ETA दिखता है।",
    "how.step_4_title": "डिलीवर हुआ",
    "how.step_4_desc": "खरीदार पुष्टि करता है, एस्क्रो रिलीज़, GST बिल ऑटो-जनरेट। एक-दूसरे को रेट करें।",
    "roles.eyebrow": "हर हिस्सेदार के लिए बना है",
    "roles.title": "छह भूमिकाएँ। एक मंच।",
    "services.eyebrow": "व्यापारी को जो चाहिए, सब यहाँ",
    "services.title": "सौदे के बाद — कागज़ी काम हम संभालेंगे।",
    "trust.eyebrow": "भरोसा डेटा पर चलता है",
    "trust.title": "हर विक्रेता। हर रेट। सत्यापित।",
    "blog.eyebrow": "मंडी ज्ञान",
    "blog.title": "हर हफ़्ते बेहतर व्यापारी।",
    "cta.title": "आधुनिक तरीके से व्यापार करने को तैयार?",
    "cta.sub": "5,000+ किसानों, व्यापारियों और निर्यातकों में शामिल हों जो फ़ोन कॉल ट्रेडिंग से एक प्लेटफ़ॉर्म पर आ चुके हैं।",
    "footer.tagline": "एक GLC Zone पहल — Mandi.GLCZone.in",
    "auth.login_title": "इंडिया मंडी पर वापस स्वागत है",
    "auth.login_sub": "एक लॉगिन। हर मंडी। असली भरोसा।",
    "auth.register_title": "इंडिया मंडी से जुड़ें",
    "auth.register_sub": "अपनी भूमिका चुनें, एक बार सत्यापन, हमेशा व्यापार।",
    "auth.email": "ईमेल",
    "auth.password": "पासवर्ड",
    "auth.name": "पूरा नाम / व्यवसाय का नाम",
    "auth.phone": "फ़ोन",
    "auth.state": "राज्य",
    "auth.district": "ज़िला",
    "auth.pincode": "पिन कोड",
    "auth.role_pick": "मैं हूँ...",
    "auth.have_account": "पहले से खाता है?",
    "auth.no_account": "नए हैं?",
    "auth.login_btn": "लॉग इन",
    "auth.register_btn": "खाता बनाएँ",
    "dash.overview": "ओवरव्यू",
    "dash.listings": "लिस्टिंग",
    "dash.deals": "सौदे",
    "dash.payments": "भुगतान",
    "dash.invoices": "इनवॉइस",
    "dash.mandis": "मंडी खोज",
    "dash.rates": "आज का भाव",
    "dash.trade": "राज्य भाव और रूट",
    "dash.blog": "मंडी ज्ञान",
    "dash.notifications": "सूचनाएँ",
    "dash.admin_users": "यूज़र",
    "dash.admin_deals": "सभी सौदे",
    "dash.admin_kyc": "KYC कागज़",
    "dash.kyc": "मेरा KYC",
    "dash.logout": "लॉग आउट",
    "kpi.viewall": "सभी देखें",
    "listings.create": "लिस्टिंग बनाएँ",
    "listings.type": "प्रकार",
    "listings.commodity": "फसल",
    "listings.qty": "मात्रा",
    "listings.price": "दाम (₹/क्विंटल)",
    "listings.location": "स्थान",
    "listings.sell": "बेचें",
    "listings.buy": "खरीदें",
    "listings.notes": "नोट्स / ग्रेड",
    "listings.submit": "लिस्टिंग प्रकाशित करें",
    "deal.status.matched": "मैच हुआ",
    "deal.status.payment_secured": "पेमेंट सुरक्षित",
    "deal.status.in_transport": "ट्रांसपोर्ट में",
    "deal.status.delivered": "डिलीवर हुआ",
    "deal.advance": "अगले चरण में जाएँ",
    "deal.finalize": "डिलीवरी पुष्टि करें",
  },
};

const HINDI_STATES = new Set([
  "Bihar", "Uttar Pradesh", "Madhya Pradesh", "Rajasthan", "Haryana",
  "Jharkhand", "Chhattisgarh", "Uttarakhand", "Delhi", "Himachal Pradesh",
]);

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("im.lang") || "en");
  useEffect(() => { localStorage.setItem("im.lang", lang); }, [lang]);
  const t = (k) => (dict[lang] && dict[lang][k]) || dict.en[k] || k;
  return (
    <I18nContext.Provider value={{ lang, setLang, t, hindiStates: HINDI_STATES }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
